/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { Link } from 'react-router-dom';
import './breadcrumbItem.less';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function BreadcrumbItem(route:any, params:any, routes:any) : JSX.Element {
  const index = routes.indexOf(route);
  const last = index === routes.length - 1;
  return last ? (
    <span className="breadcrumb__title">{route.breadcrumbName}</span>
  ) : (
    <Link
      to={route.path}
      replace
      className="breadcrumb__title"
    >
      {route.breadcrumbName}
    </Link>
  );
}

export default BreadcrumbItem;
